module.exports = __webpack_public_path__ + "static/media/Mascot_ddory_ai.d9a1c867.zip";